__turbopack_context__.v({
  "navLinkWrapper": "I6JRuW_navLinkWrapper",
  "rowDefault": "I6JRuW_rowDefault",
  "rowIcon": "I6JRuW_rowIcon",
  "rowMeta": "I6JRuW_rowMeta",
  "sectionChevron": "I6JRuW_sectionChevron",
  "sectionChevronCollapsed": "I6JRuW_sectionChevronCollapsed",
  "sectionHeader": "I6JRuW_sectionHeader",
});
